module.exports = __webpack_public_path__ + "static/fonts/Oxanium-SemiBold.eb997dd2.ttf";